import { DeleteModal as SuccessModal } from '@ui'
import successImg from '@images/success.png'

type Props = {
  onClose: () => void
  onClick: () => void
  description?: string
  title: string
  rBtnLabel: string
}

const ProductSuccess = ({ onClose, onClick, description, title, rBtnLabel }: Props) => {
  return (
    <SuccessModal
      description={description}
      gridBtn
      handleSubmit={onClick}
      headerIcon={<img alt="" className="w-[115px] h-[115px]" src={successImg} />}
      lBtnLabel="Cancel"
      onClose={onClose}
      rBtnLabel={rBtnLabel}
      title={title}
    />
  )
}

export default ProductSuccess
